































import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'contact-us',
})
export default class ContactUs extends Vue { }
